import React from 'react';
import { useTranslation } from 'react-i18next';
import { Send } from 'lucide-react';

const BotonWhatsapp = () => {
  const { t } = useTranslation();

  return (
    <a
      href={`https://wa.me/5492477551246?text=${encodeURIComponent(t('whatsapp.message'))}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t('whatsapp.label')}
      className="fixed bottom-8 right-8 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-green-500 shadow-2xl transition-transform hover:scale-110 hover:shadow-green-500/50"
    >
      <Send className="h-6 w-6 text-white" />
    </a>
  );
};

export default BotonWhatsapp;
